module.exports = require('../dist/client/future/image')
